module.exports = __webpack_public_path__ + "img/ic_items_white.d7513c2f.svg";